/**
 * (c) 2015 Ignite Sales, Inc.
 * User: aholmes
 * Date: 6/8/2016
 * Time: 9:58 AM
 */
export default {
  addGoal: {
    id: 'goal.addGoal',
    description: 'Message for adding a goal',
    defaultMessage: 'New Goal'
  },
  goalPrompt: {
    id: 'goal.prompt',
    description: 'The default message prompt for selecting your goal.',
    defaultMessage: 'What is your goal?'
  },
  timingDefault: {
    id: 'goal.timing',
    description: 'The default message prompt for the timing cell.',
    defaultMessage: 'When will you need the money?'
  },
  amountDefault: {
    id: 'goal.amount',
    description: 'The default message prompt for the amount cell.',
    defaultMessage: 'How much will you need?'
  },
  validationRequired: {
    id: 'goal.validation.required',
    description: 'The default required validation message',
    defaultMessage: 'Please provide an answer.'
  },
  validationBetween: {
    id: 'goal.validation.between',
    description: 'The min/max required validation message',
    defaultMessage: 'Amount must be between {min} and {max}'
  },
  validationMinimum: {
    id: 'goal.validation.minimum',
    description: 'The minimum required validation message',
    defaultMessage: 'Amount must be more than {min}'
  }
};



/** WEBPACK FOOTER **
 ** ./src/main/js/goalBuilder/i18n/MessageDefinitions.js
 **/